import {connect} from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import {
    getSubmitFormFieldsErrors,
    getSubmitFormSuccessStatus, resetFieldErrors
} from "../../../reducers/common/submitForm";
import {ACTION_TYPES} from "./SelfStudyDetails";
import SelfStudyDetails from "./SelfStudyDetails";
import {onCreateSelfStudyBook} from "../../../reducers/applicantSelfStudy/applicantSelfStudyBooks";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        actionType: ACTION_TYPES.ADD,
        success: getSubmitFormSuccessStatus(state),
        errors: getSubmitFormFieldsErrors(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onProcess: (data) => dispatch(onCreateSelfStudyBook(data)),
        onChangeFieldWithError: (field) => dispatch(resetFieldErrors(field))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SelfStudyDetails);



// WEBPACK FOOTER //
// ./src/components/selfStudyManagement/selfStudyDetails/SelfStudyAdd.container.js